import { SortingDirection } from './TableSortingRules.interface';
export function compareRows(a, b, sortingRules) {
    if (sortingRules.direction === SortingDirection.None) {
        return 0;
    }
    const aValue = a.data.getValue(sortingRules.columnId);
    const bValue = b.data.getValue(sortingRules.columnId);
    if (!isValidValue(aValue) && isValidValue(bValue))
        return 1;
    if (isValidValue(aValue) && !isValidValue(bValue))
        return -1;
    if (!isValidValue(aValue) && !isValidValue(bValue))
        return 0;
    let res = 0;
    if (aValue < bValue) {
        res = -1;
    }
    else if (aValue > bValue) {
        res = 1;
    }
    if (sortingRules.direction === SortingDirection.Descending) {
        res *= -1;
    }
    return res;
}
